var currentHtml = "";

var parser = require("parser");

var markdown = require("../modules/markdownwrapper/markdownwrapper");
var column = require("../modules/column/column");
var personalinfo = require("../modules/personalinfo/personalinfo");
var consentmainlabel = require("../modules/consentmainlabel/consentmainlabel");
var consent = require("../modules/consent/consent");
var consentemail = require("../modules/consentemail/consentemail");
var consentphone = require("../modules/consentphone/consentphone");
var consentpost = require("../modules/consentpost/consentpost");
var subscribe = require("../modules/subscribe/subscribe");
var contacttime = require("../modules/contacttime/contacttime");
var currentbrandselect = require("../modules/currentbrandselect/currentbrandselect");
var brochures = require("../modules/brochures/brochures");
var iscompany = require("../modules/iscompany/iscompany");
var retailers = require("../modules/retailers/retailers");
var retailersmodal = require("../modules/retailersmodal/retailersmodal");
var models = require("../modules/models/models");
var checkbox = require("../modules/checkbox/checkbox");
var dropdown = require("../modules/dropdown/dropdown");
var radiobutton = require("../modules/radiobutton/radiobutton");
var input = require("../modules/input/input");
var firstName = require("../modules/firstname/firstname");
var lastName = require("../modules/lastname/lastname");
var email = require("../modules/email/email");
var zipcode = require("../modules/zipcode/zipcode");
var pagebreak = require("../modules/pagebreak/pagebreak");
//var image = require("../modules/image/image");
var submit = require("../modules/submit/submit");
var district = require("../modules/district/district");
var regnr = require("../modules/regnr/regnr");
var commisionnumber = require("../modules/commisionnumber/commisionnumber");
var address = require("../modules/address/address");
var co = require("../modules/co/co");
var company = require("../modules/company/company");
var phone = require("../modules/phone/phone");
var message = require("../modules/message/message");
var mobile = require("../modules/mobile/mobile");
var file = require("../modules/file/file");
var terms = require("../modules/terms/terms");
var backlink = require("../modules/backlink/backlink");
var gdprtext = require("../modules/gdprtext/gdprtext");
var testvehicleslots = require("../modules/testvehicleslots/testvehicleslots");

parser.setModules(
    markdown,
    column,
    input,
    personalinfo,
    consentmainlabel,
    consent,
    consentemail,
    consentphone,
    consentpost,
    subscribe,
    contacttime,
    currentbrandselect,
    brochures,
    iscompany,
    retailers,
    retailersmodal,
    models,
    checkbox,
    dropdown,
    radiobutton,
    firstName,
    lastName,
    email,
    zipcode,
    pagebreak,
    /*image,*/
    district,
    regnr,
    commisionnumber,
    address,
    co,
    company,
    phone,
    message,
    mobile,
    file,
    submit,
    backlink,
    terms,
    gdprtext,
    testvehicleslots
);

// resets current html
function reset() {
    currentHtml = "";
}

function render(markdown, domRef, next) {

    var root;

    if( typeof domRef == 'string' ) {
        root = document.getElementById(domRef);
    }
    else {
        root = domRef;
    }

    parser.parse(markdown, function (html) {


        if (currentHtml != html) {
            root.innerHTML = html;

            currentHtml = html;

            initializeModules(root.closest("form"), function () {

            if (next && typeof next == "function") {
                next(html);
            }

        });

        } else {
            next(html);
        }

    });
}

// Go through all modules and runs their post render functions. This can be used to add interaction to modules
function initializeModules(formRoot, next) {
    if (next && typeof next == "function") {
        callInitializers(parser.getModules().concat([]), formRoot, next);
    }
}

// Go through a list of parser, wait for each to finish before going to the next
function callInitializers(moduleList, formRoot, next) {
    var module = moduleList.shift();
    if (module) {

        if (module.init && typeof module.init == "function") {

            var formData = {};
            if (typeof MBGF != "undefined" && MBGF.meta) {
                formData = MBGF.meta || {};

                // Ugly patch so we send the form data to each module. 
                // This should, ideally, be sent as a separate object, or at
                // lease not called "meta" in each module. We will fix this in time.
                formData.form = MBGF;
            }

            module.init(formRoot, formData, function (formRoot) {
                callInitializers(moduleList, formRoot, next);
            });

        } else {
            callInitializers(moduleList, formRoot, next);
        }
    }
    else {
        next(formRoot);
    }
}

module.exports = {
    render: render,
    reset: reset
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/scripts/renderer.js